import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=7a29541a&scoped=true&"
import script from "./HistoryItem.vue?vue&type=script&lang=js&"
export * from "./HistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=7a29541a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a29541a",
  null
  
)

export default component.exports